var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PreferencesPanel',{attrs:{"save":{
    text: 'Save Breakpoints',
    function: _vm.applyChanges,
    inProgress: false,
    disabled: !_vm.unsavedChangesPresent
  }},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Breakpoints")]},proxy:true},{key:"content",fn:function(){return [_c('EditBreakpoints',{attrs:{"value":_vm.internalValue},on:{"input":_vm.breakpointsEdited}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }